<template>
 <v-container fluid grid-list-md>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <v-btn color="primary" @click="warehousemark" class="mr-2">
            {{this.lang.Warehouse}}
          </v-btn>
          <v-btn color="primary" @click="warehouseuser" class="mr-2">
            {{this.lang.WarehouseUser}}
          </v-btn>
          <v-btn color="primary" @click="user" class="mr-2" v-if="admin">
            {{this.lang.Users}}
          </v-btn> 
          <v-btn color="primary" @click="bankaccount" class="mr-2" >
            {{this.lang.BankAccount}}
          </v-btn> 
          <v-btn color="primary" @click="calendar" class="mr-2" >
            {{this.lang.Calendar}}
          </v-btn>
          <v-btn color="primary" @click="termsofuse" class="mr-2" >
            {{this.lang.Terms}}
          </v-btn> 
          <v-btn color="primary" @click="docdescs" class="mr-2" >
            {{this.lang.DocDesc}}
          </v-btn> 
           <v-btn color="primary" @click="vehicles" class="mr-2" >
            {{this.lang.Vehicles}}
          </v-btn>
          <v-btn color="primary" @click="klasus" class="mr-2" >
            Klasus
          </v-btn>
          <v-btn color="primary" @click="unlock" class="mr-2" >
            eRacun UNLOCK
          </v-btn>
        </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
          <v-btn color="primary" @click="company" class="mr-2" v-if="fullAdmin">
            {{this.lang.Company}}
          </v-btn> 
          <v-btn color="primary" @click="companybusinessyear" class="mr-2" v-if="admin || fullAdmin">
            {{this.lang.CompanyBusinessYear}}
          </v-btn> 
          <v-btn color="primary" @click="companyuser" class="mr-2" v-if="admin || fullAdmin">
            {{this.lang.CompanyUsers}}
          </v-btn>
          <v-btn color="primary" @click="cardtype" class="mr-2" v-if="admin || fullAdmin">
            {{this.lang.CardType}}
          </v-btn>
          </v-col> 
          <v-col cols="12" sm="1" md="1" lg="1" xl="1">
          <v-text-field
            dense
            label="Godina"
            v-model="yearToFill"
            type="number"
            v-if="fullAdmin"
          ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3" lg="3" xl="3">
          <v-btn text color="primary" @click="updatedocdoc" class="mr-2" v-if="fullAdmin">
            Kalendar napuni
          </v-btn>
          <v-btn text color="primary" @click="updategrupe" class="mr-2" v-if="fullAdmin">
            Up.grupe u doc.det.
          </v-btn> 
        </v-col>      
     </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
          <v-btn color="primary" @click="companycreateuser" class="mr-2">
            Company
          </v-btn> 
          <v-btn color="primary" @click="companyedit" class="mr-2">
            Logo
          </v-btn> 
        </v-col>      
     </v-row>

    <div  v-if="showDocumentUnlock"> 
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
          <span class="headline">Otključavanje eRačuna </span>
        </v-col>      
      </v-row>
      <v-row> 
        <v-col cols="12" sm="2" md="2" lg="2" xl="2">
            <v-text-field
              dense
              label="Broj računa"
              v-model="documentId"
              type="number"
              v-if="fullAdmin"
              outlined
            ></v-text-field>
            <v-btn color="primary" @click="showInvoice" class="mr-2" :disabled="haveInvoice">
              Prikaži
            </v-btn> 
            <span v-if="haveInvoice"> <v-btn color="primary" @click="markUlocked" class="mr-2">
              Otključaj
            </v-btn> 
            </span>
        </v-col>
      </v-row>
      <div v-if="haveInvoice">
        <v-row>
          <v-col cols="12" sm="4" md="4" lg="4" xl="4">
            <DocumentViewCard1 />
          </v-col> 
        </v-row> 
        <v-row>
          <v-col cols="12" sm="4" md="4" lg="4" xl="4">
            <DocumentViewCard2 />
          </v-col> 
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="4" lg="4" xl="4">
            <DocumentViewCard3 />
          </v-col>     
        </v-row>
      </div>
    </div> 
    <v-row no-gutters v-if="showTerms">    
      <v-col cols="12" sm="10" md="10" lg="10" xl="10">
        <CompTermsOfUse />
      </v-col>
    </v-row> 
    <v-row no-gutters v-if="showVehicle">    
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <Vehicle />
      </v-col>
    </v-row>
    <v-row no-gutters v-if="showDocDesc">    
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <DocDesc />
      </v-col>
    </v-row>
    <div v-if="showDialog">
        <Dialog :header="header" :message="message" :dcolor="dcolor" />
    </div>
  </v-container>
</template>

<script>
import langEn from './mainDescEN'
import langHr from './mainDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import CompTermsOfUse from '@/components/Companies/CompTermsOfUse'
import Vehicle from '@/components/Vehicle/VehicleIndex'
import DocDesc from '@/components/DocDesc/DocDescIndex'
import DocumentViewCard1 from '@/components/Document/DocumentViewCard1'
import DocumentViewCard2 from '@/components/Document/DocumentViewCard2'
import DocumentViewCard3 from '@/components/Document/DocumentViewCard3'
import Dialog from '@/snippets/Dialog'
import { f } from 'pdfmake/build/pdfmake'

export default {
  name: 'appsettings',
  data () {
    return {
      menu: false,
      modal: false,
      msg: '',
      valid: true,
      account: { },
      error: null,
      localError: false,
      privGroups: [],
      lang: {},
      langC: {},
      saving: false,
      admin: false,
      showTerms: false,
      showBeton: false,
      showTvrtka: false,
      showKorisnik: false,
      showObjekt: false,
      showVehicle: false,
      showDocDesc: false,
      mainQuery: {},
      userIsBeton: false,
      fullAdmin: false,
      yearToFill: new Date().getFullYear(),
      showDocumentUnlock: false,
      invoiceNr: 0,
      showDetailInvoice: false,
      eRacunDialog: false,
      showDialog: false,
      dcolor: 'success',
      header: '',
      message: '',
      documentId: 0,
      haveInvoice: false

    }
  },
  components: {
    CompTermsOfUse,
    Vehicle,
    DocDesc,
    DocumentViewCard1,
    DocumentViewCard2,
    DocumentViewCard3,
    Dialog
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
        this.lang = langEn
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = langHr
        this.langC = commHr;
      }

      if (this.$store.state.user.Admin) {
        this.fullAdmin = this.$store.state.user.Admin
      }
      if (this.$store.state.user.admin2) {
        this.admin = this.$store.state.user.admin2
      }
      this.userIsBeton = this.$store.state.user.beton ? this.$store.state.user.beton : false
  },
  methods: {
    termsofuse(){
      this.showTerms = !this.showTerms
    },
    vehicles() {
      this.showVehicle = !this.showVehicle
    },
    docdescs() {
      this.showDocDesc = !this.showDocDesc
    },
    unlock() {
      this.haveInvoice = false
      this.showDocumentUnlock = !this.showDocumentUnlock
    },
    reseteRacunDialog() {
      this.$store.dispatch('setDocumentActivHead', {})
      this.$store.dispatch('setDocumentActivItems', [])
      this.showDocumentUnlock = false
      this.invoiceNr = 0
      this.showDetailInvoice = false
    },
    async showInvoice () {
      try {
        this.dcolor = 'success'
        this.haveInvoice = false
        let notSet = true
        this.$store.dispatch('setDocumentActivHead', {})
        this.showDialog = false
        this.$store.dispatch('setDialogState', false)
        const query = {}
        query.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
        query.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2021
        query.documentName = 'InvoiceSales'
        query.documentId = this.documentId ? parseInt(this.documentId) : 0
        // find invoice and show 
        const dbDocument = await DocumentService.onlyoneneed(query)
        if (dbDocument && dbDocument.data && dbDocument.data.document) {
          notSet = false
          const docLocked = dbDocument.data.document.documentLocked
          if (docLocked) {
            this.$store.dispatch('setDocumentActivHead', dbDocument.data.document)
            console.log('dbDocument.data.document', dbDocument.data.document)
            this.haveInvoice = true
          }
          if (!docLocked) {
            this.dcolor = 'error'
            this.header = ' Error!'
            this.message = 'Error Invoice is not locked. Greška, račun s tim brojem nije zaključan!'
            this.showDialog = true
            this.$store.dispatch('setDialogState', true)
            this.$store.dispatch('setDocumentActivHead', {})
          }
        } 

        if (notSet) {
          this.dcolor = 'error'
          this.header = ' Error!'
          this.message = 'Error Invoice not exist. Greška, račun s tim brojem ne postoji!'
          this.showDialog = true
          this.$store.dispatch('setDialogState', true)
          this.$store.dispatch('setDocumentActivHead', {})
        }
          
      } catch (error) {
        console.log(error)
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = 'Error on search invoice! Greška kod traženja računa!'
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
    },
    async markUlocked() {
      try {
        const doc = this.$store.state.documentActivHead
        doc.documentLocked = false
        doc.documentLockedDate = null
        doc.documentLockedTime = null
        doc.documentLockedBy = null
        doc.RespondedStatus = null
        doc.documentUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
        const resp = await DocumentService.put(doc)
        if (resp && resp.data) {
          this.haveInvoice = false
          this.$store.dispatch('setDocumentActivHead', {})
          this.dcolor = 'success'
          this.header = ' OK!'
          this.message = 'Ulocked! Otkljucan!'
          this.showDialog = true
        }
      } catch (error) {
        console.log(error)
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = 'Error on search invoice! Greška kod traženja računa!'
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
    },
    async klasus () {
      try {
        await this.$router.push({
          name: 'klasus'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async warehousemark () {
      try {
        await this.$router.push({
          name: 'warehousemark'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async warehouseuser () {
      try {
        await this.$router.push({
          name: 'warehouseuser'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async user () {
      try {
        await this.$router.push({
          name: 'user'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async bankaccount () {
      try {
        await this.$router.push({
          name: 'bankaccount'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async calendar () {
      try {
        await this.$router.push({
          name: 'calendar'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async company () {
      try {
        await this.$router.push({
          name: 'company'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async company () {
      try {
        await this.$router.push({
          name: 'company'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companycreateuser () {
      try {
        await this.$router.push({
          name: 'companycreateuser'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companyedit () {
      try {
        await this.$router.push({
          name: 'companyedit'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companybusinessyear () {
      try {
        await this.$router.push({
          name: 'companybusinessyear'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companyuser () {
      try {
        await this.$router.push({
          name: 'companyuser'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async cardtype () {
      try {
        await this.$router.push({
          name: 'cardtype'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async updatedocdoc () {
      try {
        const yearTofill = {
          year: this.yearToFill
        }
        await DocumentService.updatedocdoc(yearTofill)
        alert('Kalendar napunjen!')
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async updategrupe () {
      try {
        const itemsLoc = this.$store.state.itemStore ? this.$store.state.itemStore : []
        this.mainQuery.BusinessYear = this.$store.state.businessYear
        const needUpdate = []
        this.mainQuery.CompanyId = this.$store.state.companyid
        this.mainQuery.docFromDate = new Date(new Date().getFullYear(), 0, 1)
        this.mainQuery.docToDate = new Date(new Date().getFullYear(), 11, 31)


        await DocumentDetailService.salesana(this.mainQuery)
        .then(res => {
          const itemDetails = res.data.document ? res.data.document : []
          console.log('Sve stavke u dok.detalis ', itemDetails)
          if (itemDetails) {
            itemDetails.map(item=> {
              if (!item.itemGroup || !item.itemGroupName) {
                let addItem = true
                if (needUpdate) {
                  const marked = needUpdate.find(nitem => {nitem.itemID === item.itemID})
                  if (marked) {
                    addItem = false
                  }
                }
                if (addItem) {
                  const haveItem = itemsLoc.find(fitem => fitem.itemID === item.itemID)
                  const newItem = {}
                  newItem.CompanyId = this.$store.state.companyid
                  newItem.BusinessYear = this.$store.state.businessYear
                  newItem.itemID = item.itemID
                  newItem.GroupId = haveItem.GroupId
                  newItem.GroupName = haveItem.GroupName
                  needUpdate.push (newItem)
                }
              }
            })
          }
          console.log('Trebaju update  ', needUpdate)
          if (needUpdate) {
            needUpdate.map(async(upitem) => {
              await DocumentDetailService.updateitems(upitem)
            })
          }
          console.log('Update done  !!')
        })
        .catch((err) => {
          console.log(err)
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },

  },
  computed: {
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
